interface HeroBalanceCardProps {
  totalHsaBalance: number;
  accountCount: number;
}

export function HeroBalanceCard({ totalHsaBalance, accountCount }: HeroBalanceCardProps) {
  const formattedBalance = totalHsaBalance.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <div className="bg-gradient-to-br from-[#1B365D] to-[#2D4A7C] rounded-lg p-8 text-white">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-[14px] font-medium text-white/80 mb-2">
            Total HSA Balance
          </div>
          <div className="text-[48px] font-semibold mb-1 font-mono">
            ${formattedBalance}
          </div>
          <div className="text-[13px] text-white/70">
            across {accountCount} {accountCount === 1 ? 'account' : 'accounts'}
          </div>
        </div>
      </div>
    </div>
  );
}
